import { Transform } from 'class-transformer';
import { dateTransform } from '../utils/helper';

export class Qualification {
    id!: number;
    actorid!: number;
    name!: string;
    note?: string;
    @Transform(dateTransform)
    expirydate?: Date;
    @Transform(dateTransform)
    renewdate?: Date;
    @Transform(dateTransform)
    achievementdate?: Date;
    @Transform(dateTransform)
    insdate?: Date;
    @Transform(dateTransform)
    moddate?: Date;
}
